<template>
    <div class="main-nav-wrap">
        <ul class="main-nav">
            <router-link to="/" tag="li">Home</router-link>
            <router-link to="/order/upload-artwork" tag="li">Add Images</router-link>
            <router-link to="/order/design" tag="li">Designs</router-link>
            <router-link to="/order/choose-garment" tag="li">Order</router-link>
            <li v-on:click="logIn">Log In</li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'Menu',
    methods: {
        logIn() {
            this.$store.dispatch('openLogin');
        },
    },
};
</script>


// WEBPACK FOOTER //
// src/components/Header/Menu.vue